function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 385",
  fill: "none",
  stroke: "#3c00dc"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 310",
  strokeDasharray: "1 1"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M13 0v9H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5.5v8H.5v-8z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 312",
  strokeDasharray: "1 1"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M34 0v9H16V0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.5.5v8h-17v-8z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 311"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M34 12v9H0v-9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.5 12.5v8H.5v-8z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 313"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M34 24v9H0v-9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.5 24.5v8H.5v-8z"
})));

function SvgStackinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 33,
    viewBox: "0 0 34 33"
  }, props), _ref);
}

export default SvgStackinline;